import SwiperSlider from "../base";

const selectors = {
  sliderEl: "[data-comp-general-slider]",
  nextEl: "[data-navigation-next-el]",
  prevEl: "[data-navigation-prev-el]",
  paginationEl: "[data-pagination-el]",
};

const swiperOptions = {
  slidesPerView: "auto",
  spaceBetween: 14,
  speed: 600,
  slidesOffsetAfter: 32,
  navigation: {
    nextEl: selectors.nextEl,
    prevEl: selectors.prevEl,
  },
  pagination: {
    el: selectors.paginationEl,
    clickable: true,
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
    },
  },
};

export default class sectionGeneralSlider extends SwiperSlider {
  static loaderPriority = "in-view";
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.generalSlider = new this.Swiper(this.$container, swiperOptions);
    this.nextEl = this.$container.querySelector(selectors.nextEl);
    this.prevEl = this.$container.querySelector(selectors.prevEl);
    this.addListeners();
  }

  addListeners() {
    this.addSlideChangeListener();
    this.addOnUnloadListener();
  }

  addSlideChangeListener() {
    this.dispatchResizeEvent = dispatchResizeEvent.bind(this);
    this.generalSlider.on("slideChange", this.dispatchResizeEvent);
  }

  addOnUnloadListener() {
    window.onunload = () => {
      this.removeSlideChangeListener();
    };
  }

  removeSlideChangeListener() {
    this.generalSlider.off("slideChange", this.dispatchResizeEvent);
  }
}

function dispatchResizeEvent() {
  window.dispatchEvent(new Event("resize"));
}
